<i18n
  src="@/locales/components/views/service_provider/services/container_op/container_schedule_service_info.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container_scheduled_service.yml" lang="yaml"></i18n>
<template>
  <div class="mt-8">
    <div class="panel">
      <div class="panel-header columns-2">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>
      <div class="panel-body" v-if="container_scheduled_service">
        <div class="space-y-8 divide-y divide-slate-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container_scheduled_service.agro_exporter_id") }}
              </dt>
              <dd class="content-data">
                {{ container_scheduled_service.agro_exporter?.name }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <template v-if="container_scheduled_service.container">
                <dt class="label-data">
                  {{ $t("model.container_scheduled_service.container_id") }}
                </dt>
                <dd class="content-data">
                  {{ container_scheduled_service.container?.container_code }}
                </dd>
              </template>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container_scheduled_service.scheduled_at") }}
              </dt>
              <dd class="content-data">
                {{
                  dateFormatter(
                    container_scheduled_service.scheduled_at,
                    "DD MMM YYYY hh:mm A",
                    "YYYY-MM-DDTHH:mm:ss"
                  )
                }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container_scheduled_service.status_id") }}
              </dt>
              <dd class="content-data">
                <container-scheduled-service-status
                  :status_id="container_scheduled_service.status_id"
                />
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container_scheduled_service.started_at") }}
              </dt>
              <dd class="content-data">
                {{
                  dateFormatter(
                    container_scheduled_service.started_at,
                    "DD MMM YYYY hh:mm A",
                    "YYYY-MM-DDThh:mm:ss"
                  )
                }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container_scheduled_service.finished_at") }}
              </dt>
              <dd class="content-data">
                {{
                  dateFormatter(
                    container_scheduled_service.finished_at,
                    "DD MMM YYYY hh:mm A",
                    "YYYY-MM-DDTHH:mm:ss"
                  )
                }}
              </dd>
            </div>
            <div
              class="sm:col-span-6"
              v-if="container_scheduled_service.observations"
            >
              <dt class="label-data">
                {{ $t("model.container_scheduled_service.observations") }}
              </dt>
              <dd class="content-data">
                {{ container_scheduled_service.observations }}
              </dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerScheduledServiceStatus from "@/components/views/service_provider/services/container_op/ContainerScheduledServiceStatus.vue";

export default {
  components: {
    ContainerScheduledServiceStatus,
  },
  props: ["container_scheduled_service"],
  data() {
    return {
      open: false,
    };
  },
};
</script>

